import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { getLabelsByCategoryAndSection } from '../../api/api.js';
import '../../App.css';
import { enterPtsEdit, exitPtsEdit } from "../utils/ptsEditMode.js";
import { usePTS } from '../../context/PTSContext.js';
import { exportTekniikkatauluToExcel } from '../utils/exportTekniikkatauluToExcel.js';

// showAlvZero only swaps the header label text (ALV 0% vs sis. Alv 25,5%) —
// it's purely a display label, no recalculation of any figures.
const Tekniikkataulut = forwardRef(({ type, hideKuntoluokka = false, showAlvZero = false, hide11thYear = false }, ref) => {
    const {
      years: allYears,
      currentYear,
      tekniikkaData, setTekniikkaData,
      lviData, setLviData,
      sahkoData, setSahkoData,
      tutkimusData, setTutkimusData,
      tekniikkaYhteensa,
      lviYhteensa,
      sahkoYhteensa,
      handleSavePTS,
      removeTableRow
    } = usePTS();
    // hide11thYear only truncates what's displayed — the underlying 11-value
    // arrays in tekniikkaData/lviData/etc. are never touched, so turning the
    // setting back off shows the last year's data again unchanged.
    const years = hide11thYear ? allYears.slice(0, 10) : allYears;
  let initialData;

  if (type === 'Sähköjärjestelmät') {
    initialData = [
      { name: 'Aluesähköistys', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Kytkinlaitokset ja jakokeskukset', kl: '', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Johdot ja niiden varusteet', kl: 'K', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Valaisimet, lämmittimet, kojeet ja laitteet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Tele- ja antennijärjestelmät', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Palo- ja turvajärjestelmät', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Siirtolaitteet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
    ];
  } else if (type === 'LVI Järjestelmät') {
    initialData = [
      { name: 'Lämmöntuotanto', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Lämmitysverkosto', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Vesijohtoverkosto', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Viemäriverkosto', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Ilmanvaihtojärjestelmä', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Jäähdytysjärjestelmät', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Rakennusautomaatio', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Muut järjestelmät', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
    ];
  } else if (type === 'Rakennetekniikka') {
    initialData = [
      { name: 'Vierustat ja kuivatusosat', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Pihapäällysteet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Aluevarusteet ja -rakenteet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Perustukset ja sokkelit', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Alapohja', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Rakennusrunko', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Ulkoseinät', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Ikkunat', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Ulko-ovet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Parvekkeet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Kattorakenteet', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Sisätilat', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
      { name: 'Märkätilat', kl: ' ', items: [{ label: '', kl: ' ', values: Array(11).fill('') }] },
    ];
  }
  
  const initialDataMap = {
    'Sähköjärjestelmät': sahkoData,
    'LVI Järjestelmät': lviData,
    'Rakennetekniikka': tekniikkaData
  };

  const [tableData, setTableData] = useState(initialDataMap[type] || []);

  const [originalData, setOriginalData] = useState(tableData);
  const [isEditing, setIsEditing] = useState(false);

const registeredRef = useRef(false);

useEffect(() => {
  if (isEditing && !registeredRef.current) {
    enterPtsEdit();
    registeredRef.current = true;
  }

  if (!isEditing && registeredRef.current) {
    exitPtsEdit();
    registeredRef.current = false;
  }

  return () => {
    if (registeredRef.current) {
      exitPtsEdit();
      registeredRef.current = false;
    }
  };
}, [isEditing]);


  const syncToContext = (updatedTableData) => {
  switch (type) {
    case 'Rakennetekniikka':
      setTekniikkaData(updatedTableData);
      break;
    case 'LVI Järjestelmät':
      setLviData(updatedTableData);
      break;
    case 'Sähköjärjestelmät':
      setSahkoData(updatedTableData);
      break;
    default:
      break;
  }
};

  const isNumeric = (v) =>
    typeof v === "number" ||
    (typeof v === "string" && v.trim() !== "" && !isNaN(Number(v)));
  
  // Initialize tableData only when context has data
  useEffect(() => {
    let data;
    switch (type) {
      case 'Sähköjärjestelmät':
        data = sahkoData;
        break;
      case 'LVI Järjestelmät':
        data = lviData;
        break;
      case 'Rakennetekniikka':
        data = tekniikkaData;
        break;
      default:
        data = [];
    }

    if (data && data.length > 0) {
      setTableData(data);
      syncToContext(data);
      setOriginalData(JSON.parse(JSON.stringify(data))); // store for cancel
    }
  }, [type, tekniikkaData, lviData, sahkoData]); // listen for context updates

  const handleValueChange = (sectionIdx, itemIdx, yearIdx, value) => {
    const updated = structuredClone(tableData);
    updated[sectionIdx].items[itemIdx].values[yearIdx] = value;
    setTableData(updated);
    syncToContext(updated);
  };


  const handleLabelChange = (sectionIdx, itemIdx, value) => {
    const updated = structuredClone(tableData);
    updated[sectionIdx].items[itemIdx].label = value;
    setTableData(updated);
    syncToContext(updated);
  };

  const handleKLChange = (sectionIdx, itemIdx, value) => {
    const updated = structuredClone(tableData);
    updated[sectionIdx].items[itemIdx].kl = value;
    setTableData(updated);
    syncToContext(updated);
  };

  const handleAddRow = (sectionIdx) => {
    const updated = structuredClone(tableData);
    updated[sectionIdx].items.push({
      label: '',
      kl: '',
      values: Array(11).fill('')
    });
    setTableData(updated);
    syncToContext(updated);
  };



const handleRemoveRow = (sectionIdx, itemIdx) => {
  removeTableRow(type, sectionIdx, itemIdx);
};

  const totalsByType =
    type === 'Rakennetekniikka' ? tekniikkaYhteensa :
    type === 'LVI Järjestelmät' ? lviYhteensa :
    type === 'Sähköjärjestelmät' ? sahkoYhteensa :
    [];

  function getKLColor(kl) {
    switch (kl) {
      case 'KL1':
      case 'KL2':
        return '#ba3b46';
      case 'KL3':
        return '#d0c407';
      case 'KL4':
      case 'KL5':
        return '#04aa00';
      default:
        return 'black';
    }
  }

  const [labelsBySection, setLabelsBySection] = useState({});

  useEffect(() => {
    if (!isEditing || !type || tableData.length === 0) return;
    let isMounted = true;

    const fetchLabels = async () => {
      try {
        const results = await Promise.all(
          tableData.map(section => getLabelsByCategoryAndSection(type, section.name))
        );
        if (!isMounted) return;
        const labelsMap = {};
        tableData.forEach((section, idx) => {
          labelsMap[section.name] = results[idx].data.labels;
        });
        setLabelsBySection(labelsMap);
      } catch (err) { console.error(err); }
    };

    fetchLabels();
    return () => { isMounted = false };
  }, [isEditing, type, tableData.map(s => s.name).join(',')]);


  const handleEditToggle = (category = "Rakennetekniikka") => {
    // Get the proper data array from context
    const dataMap = {
      'Rakennetekniikka': tekniikkaData,
      'LVI Järjestelmät': lviData,
      'Sähköjärjestelmät': sahkoData,
      'Lisätutkimukset': tutkimusData
    };
    const setDataMap = {
      'Rakennetekniikka': setTekniikkaData,
      'LVI Järjestelmät': setLviData,
      'Sähköjärjestelmät': setSahkoData,
      'Lisätutkimukset': setTutkimusData
    };

    const tableData = dataMap[category];

    if (!isEditing) {
      // ✏️ Entering edit mode
      setOriginalData(JSON.parse(JSON.stringify(tableData || [])));
      setIsEditing(true);
    } else {
      // 💾 Saving
      if (tableData?.[0]?.items?.[0]?.values) {
        console.log(
          "🚨 SAVEPTS PAYLOAD values:",
          JSON.stringify(tableData[0].items[0].values)
        );
      }

    handleSavePTS(type);

      // 🧩 Detect newly added or edited row
      try {
        let changedSection = null;
        let changedItem = null;

        for (let i = 0; i < (tableData || []).length; i++) {
          const newSec = tableData[i];
          const oldSec = originalData?.[i] || { items: [] };
          const oldLabels = (oldSec.items || []).map((x) => x.label?.trim());
          const newItems = (newSec.items || []).filter(
            (x) => !oldLabels.includes(x.label?.trim()) && x.label?.trim() !== ""
          );

          if (newItems.length > 0) {
            changedSection = newSec;
            changedItem = newItems[newItems.length - 1];
            break;
          }
        }

        // fallback: last non-empty row if diff not found
        if (!changedItem) {
          const filled = (tableData || [])
            .flatMap((s) => s.items.map((it) => ({ section: s, item: it })))
            .filter((x) => x.item.label?.trim());
          if (filled.length) {
            const { section, item } = filled[filled.length - 1];
            changedSection = section;
            changedItem = item;
          }
        }

        if (changedItem && changedSection) {
          const normalizedRow = {
            section: changedSection.name,
            label: changedItem.label,
            category: category || "Muu",
            metadata: {},
          };
          console.log("✅ Detected changed row:", normalizedRow);
        } else {
          console.warn("⚠️ No changed row detected for onRowSaved");
        }
      } catch (err) {
        console.warn("⚠️ Could not propagate row to report:", err);
      }

      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    if (originalData && originalData.length > 0) {
      setTableData(structuredClone(originalData));
      syncToContext(originalData);
    }
    setIsEditing(false);
  };

 return (
  <div className={`my-4 ptstaulut ${isEditing ? "pts-edit-wide" : ""}`}>

    {/* Edit / Save / Cancel buttons */}
    <div className="text-center mb-2">
      {isEditing ? (
        <>
          <button className="btn btn-sm btn-success me-2" onClick={handleEditToggle}>Tallenna</button>
          <button className="btn btn-sm btn-secondary" onClick={handleCancel}>Peruuta</button>
        </>
      ) : (
        <>
          <button className="btn btn-sm btn-success me-2" onClick={handleEditToggle}>Muokkaa</button>
          <button
            className="btn btn-sm btn-outline-success"
            onClick={() => exportTekniikkatauluToExcel({ type, tableData, totalsByType, years })}
          >
            Lataa Excel
          </button>
        </>
      )}
    </div>

    <div className="table-responsive" ref={ref}>
      <table className="table table-sm table-borderless mb-0">
        <thead>
          <tr>
            <th colSpan={years.length + (hideKuntoluokka ? 1 : 2) + (isEditing ? 1 : 0)} className="bg-success text-white p-2">
              {!isEditing && (
                <div className="small text-end">
                  {showAlvZero
                    ? `Kustannusarvio (x 1000€) Kustannustaso ${currentYear} ALV 0%`
                    : `Kustannusarvio (x 1000€) Kustannustaso ${currentYear} sis. Alv 25,5%`}
                </div>
              )}
            </th>
          </tr>
        </thead>

        <thead>
          <tr>
            <th className="bg-success text-white text-start">{type}</th>
            {!hideKuntoluokka && <th className="bg-success text-white text-center"></th>}
            {years.map(year => (
              <th key={year} className="bg-success text-white text-center px-2 fw-bold">{year}</th>
            ))}
            {isEditing && <th className="bg-success text-white"></th>}
          </tr>
        </thead>

        <tbody>
          {tableData.map((section, sectionIdx) => (
            <React.Fragment key={sectionIdx}>
              {/* Section header */}
              <tr>
                <td className="bg-light fw-semibold text-dark p-2">
                  <div className="d-flex align-items-center">
                    {isEditing && (
                      <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => handleAddRow(sectionIdx)}>+</button>
                    )}
                    <span>{section.name}</span>
                  </div>
                </td>
                {!hideKuntoluokka && (() => {
                const numbers = section.items
                  .map(item => parseInt(item.kl.replace('KL','')))
                  .filter(num => !isNaN(num));

                const avgKL = numbers.length === 0
                  ? ''
                  : 'KL' + Math.round(numbers.reduce((a, b) => a + b, 0) / numbers.length);

                return (
            <td
              className="bg-light text-center fw-semibold align-middle"
              style={{ color: avgKL ? getKLColor(avgKL) : 'inherit' }}
            >
              {avgKL}
            </td>
          );
                 })()}

                <td colSpan={years.length + (isEditing ? 1 : 0)} className="bg-light"></td>
              </tr>

              {/* Repeated year header between rows */}
              {isEditing && (
                <tr>
                  <td className="bg-light text-start fw-semibold" colSpan={hideKuntoluokka ? 1 : 2}></td>
                  {years.map(year => (
                    <td key={year} className="bg-light text-center text-muted px-2">{year}</td>
                  ))}
                  {isEditing && <td className="bg-light"></td>}
                </tr>
              )}

              {/* Section items */}
                          {section.items.map((item, itemIdx) => (
                            <tr key={itemIdx}>
                      <td style={{ maxWidth: '320px' }}>
              {isEditing ? (
                <div style={{ width: '100%' }}>
                  {/* INPUT — stays compact */}
                  <input
                    type="text"
                    list={`labels-${sectionIdx}-${itemIdx}`}
                    value={item.label || ''}
                    onChange={e =>
                      handleLabelChange(sectionIdx, itemIdx, e.target.value)
                    }
                    className="form-control form-control-sm"
                    placeholder="Freewrite or select..."
                    style={{
                      width: '100%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  />

                  
                

                  <datalist id={`labels-${sectionIdx}-${itemIdx}`}>
                    {(labelsBySection[section.name] || []).map((opt, idx) => (
                      <option key={idx} value={opt} />
                    ))}
                  </datalist>
                </div>
              ) : (
                <div
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    maxHeight: '4.5em',
                    overflowY: 'auto',
                  }}
                >
                  {item.label}
                </div>
              )}
            </td>


                  {!hideKuntoluokka && (
                    <td className="px-1" style={{ minWidth: '70px' }}>
                      {isEditing ? (
                        <select
                          value={item.kl}
                          onChange={e => handleKLChange(sectionIdx, itemIdx, e.target.value)}
                          className="form-select form-select-sm"
                          style={{ minWidth: '70px' }}
                        >
                          {[' ','KL1','KL2','KL3','KL4','KL5'].map(kl => <option key={kl} value={kl}>{kl}</option>)}
                        </select>
                      ) : null}
                    </td>
                  )}

                  {item.values.slice(0, years.length).map((val, yearIdx) => (
                    <td key={yearIdx} className="text-center px-1">
                      {isEditing ? (
                        <input
                          type="text"
                          value={val === 0 || val === '0' ? '' : val}
                          onChange={e => handleValueChange(sectionIdx, itemIdx, yearIdx, e.target.value)}
                          className={`form-control form-control-sm text-center ${
                            isNumeric(val) && Number(val) > 0 ? 'bg-success text-white' : ''
                          }`}
                          style={{
                            width: '100%',
                            minWidth:'40px',
                            maxWidth:'100%',
                            boxSizing:'border-box',
                            padding:'2px 4px',
                            textOverflow:'ellipsis',
                            overflow:'hidden',
                            whiteSpace:'nowrap',
                          }}
                        />
                      ) : (!val || (isNumeric(val) && Number(val) === 0) ? '' : val)}
                    </td>
                  ))}
                  {isEditing && (
                    <td>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveRow(sectionIdx,itemIdx)}>×</button>
                    </td>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>

          <tfoot>
            <tr className="fw-bold">
              <td className="bg-success text-white text-start">YHTEENSÄ</td>
              {!hideKuntoluokka && <td className="bg-success text-white"></td>}

              {totalsByType.slice(0, years.length).map((sum, idx) => (
                <td
                  key={idx}
                  className="bg-success text-white text-center font-monospace px-2"
                >
                  {sum}
                </td>
              ))}

              {isEditing && <td className="bg-success text-white"></td>}
            </tr>
          </tfoot>
      </table>
    </div>
  </div>
);

});

export default Tekniikkataulut;